import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import VDKEventResponseAPI from '@infrastructure/vdk-event-response-api';
export const getStepsFieldsResponsesByRegistrationIdAsync = createAsyncThunk('/vdk-event-responses/get-steps-fields-responses-by-registration-id', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.getStepsFieldsResponsesByRegistrationId(request.registrationId, request.eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllActiveResponsesByEventIdGroupedByRegistrationAsync = createAsyncThunk('/vdk-event-responses/get-all-active-responses-by-event-id-grouped-by-registration', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.getAllActiveResponsesByEventIdGroupedByRegistration(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllArchivedResponsesByEventIdGroupedByRegistrationAsync = createAsyncThunk('/vdk-event-responses/get-all-archived-responses-by-event-id-grouped-by-registration', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.getAllArchivedResponsesByEventIdGroupedByRegistration(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllResponsesGridLabelsByEventIdAsync = createAsyncThunk('/vdk-event-responses/get-all-responses-grid-labels-by-event-id', async (eventId, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.getAllResponsesGridLabelsByEventId(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllResponsesLabelsByEventIdAsync = createAsyncThunk('/vdk-event-responses/get-all-responses-labels-by-event-id', async (eventId, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.getAllResponsesLabelsByEventId(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateResponseGridLabelsAsync = createAsyncThunk('/vdk-event-responses/update-response-grid-labels', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.updateResponseGridLabels(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateResponsesAsync = createAsyncThunk('/vdk-event-responses/update-responses', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.updateResponses(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const archiveResponsesAsync = createAsyncThunk('/vdk-event-responses/archive-responses', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.archiveResponses(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const unarchiveResponsesAsync = createAsyncThunk('/vdk-event-responses/unarchive-responses', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.unarchiveResponses(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteResponsesAsync = createAsyncThunk('/vdk-event-responses/delete-responses', async (request, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.deleteResponses(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const exportResponsesToExcelAsync = createAsyncThunk('/vdk-event-responses/export-responses-to-excel', async (eventId, { rejectWithValue }) => {
    try {
        const response = await VDKEventResponseAPI.exportResponsesToExcel(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
